import { render, staticRenderFns } from "./novel_extensionLink.vue?vue&type=template&id=7c0f521a&scoped=true&"
import script from "./novel_extensionLink.vue?vue&type=script&lang=js&"
export * from "./novel_extensionLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0f521a",
  null
  
)

export default component.exports